// ABOUTME: Route file for /login.
// ABOUTME: Renders the LoginPage component.

import LoginPage from "@/pages/LoginPage";
import { createFileRoute } from "@tanstack/react-router";

interface LoginSearchParams {
  redirect?: string;
}

export const Route = createFileRoute("/login")({
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => {
    const raw = search.redirect;
    // Only honor internal, relative paths to prevent open-redirect.
    const redirect =
      typeof raw === "string" && raw.startsWith("/") && !raw.startsWith("//")
        ? raw
        : undefined;
    return { redirect };
  },
  component: LoginPage,
});
